import Box from '@mui/material/Box'
import Tab from '@mui/material/Tab'
import Tabs from '@mui/material/Tabs'
import React from 'react'

import { type CampaignItem } from '@/app/module/campaigns/types'
import { type CountryTimezone, type Timezones } from '@/app/types'

import ContactSubscriptionsTable from './contacts-table'
import { GroupSubscriptionsTable, SegmentSubscriptionsTable } from './groups-table'

type SubscriptionTab = 'contacts' | 'groups' | 'segments'

type Props = {
  countriesTimezones: CountryTimezone[]
  countryCode: string
  item?: CampaignItem
  itemId: number
  orgId: number
  timezone: string
  timezones: Timezones
}

const CampaignSubscriptions: React.FC<Props> = (props) => {
  const { countriesTimezones, countryCode, item, itemId, orgId, timezone, timezones } = props

  const [tab, setTab] = React.useState<SubscriptionTab>('contacts')

  const renderContactsTable = () => {
    if (!item) {
      return null
    }
    return (
      <ContactSubscriptionsTable
        campaign={item}
        campaignId={itemId}
        countriesTimezones={countriesTimezones}
        countryCode={countryCode}
        timezone={timezone}
        timezones={timezones}
      />
    )
  }

  const renderGroupsTable = () => {
    if (!item) {
      return null
    }
    return (
      <GroupSubscriptionsTable
        orgId={orgId}
        campaign={item}
        campaignId={itemId}
        timezone={timezone}
        timezones={timezones}
        countriesTimezones={countriesTimezones}
        countryCode={countryCode}
      />
    )
  }

  const renderSegmentsTable = () => {
    if (!item) {
      return null
    }
    return (
      <SegmentSubscriptionsTable
        orgId={orgId}
        campaign={item}
        campaignId={itemId}
        timezone={timezone}
        timezones={timezones}
        countriesTimezones={countriesTimezones}
        countryCode={countryCode}
      />
    )
  }

  return (
    <>
      <Box sx={{ backgroundColor: '#f5f5f5' }}>
        <Tabs
          value={tab}
          indicatorColor="primary"
          sx={(theme) => ({
            maxWidth: '100%',
            [theme.breakpoints.down('md')]: {
              '& .MuiTabs-flexContainer': {
                width: '100%',
              },
              '& .MuiTab-root': {
                flex: '1 1 0',
                maxWidth: 'none',
                minWidth: 0,
                paddingX: 1,
              },
            },
          })}
          onChange={(_, value: SubscriptionTab) => setTab(value)}
        >
          <Tab value="contacts" label="Contacts" className="subscription-tab-contacts" />
          <Tab value="groups" label="Groups" className="subscription-tab-groups" />
          <Tab value="segments" label="Segments" className="subscription-tab-segments" />
        </Tabs>
      </Box>

      {/* orgId can be 0 when loading the app the first time (navigated by URL) */}
      {!!orgId && tab === 'contacts' && renderContactsTable()}
      {!!orgId && tab === 'groups' && renderGroupsTable()}
      {!!orgId && tab === 'segments' && renderSegmentsTable()}
    </>
  )
}

export default CampaignSubscriptions
